import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

export const PartnerInvite = ({ kase }) => {
  const qc = useQueryClient();
  const [form, setForm] = useState({ first_name: "", email: "" });
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const partner = kase.participants.find((p) => !p.is_me);
  const pending = kase.partner_invites.find((i) => i.status === "pending");

  const send = async () => {
    setBusy(true);
    try {
      await api.post("/portal/case/invite-partner", form);
      qc.invalidateQueries({ queryKey: ["portal"] });
      toast.success(`Invitation sent to ${form.email}.`);
      setOpen(false);
      setForm({ first_name: "", email: "" });
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  if (partner) return <p className="text-ink-900" data-testid="partner-joined">{partner.first_name} has joined your care journey. You each watch the series at your own pace.</p>;
  if (!kase.is_primary) return null;
  return (
    <div className="text-ink-900" data-testid="partner-invite">
      {pending && !open && <p data-testid="partner-invite-pending">Invitation sent to {pending.first_name} ({pending.email}). It is valid for 14 days.</p>}
      {!open ? (
        <button type="button" className="btn-secondary mt-3" onClick={() => setOpen(true)} data-testid="partner-invite-open">{pending ? "Send A New Invitation" : "Invite Your Spouse Or Partner"}</button>
      ) : (
        <div className="surface mt-3 p-4">
          <p className="font-serif text-lg font-semibold">Invite Your Partner</p>
          <p className="mt-1 text-sm text-ink-500">They receive an email link, create a free account, and join this case. Both of you complete the video series before in-person counseling.</p>
          <div className="mt-3 grid gap-3 sm:grid-cols-2">
            <div><label htmlFor="pi-name" className="label text-sm">Their first name</label><input id="pi-name" className="input" value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} data-testid="partner-first-name" /></div>
            <div><label htmlFor="pi-email" className="label text-sm">Their email</label><input id="pi-email" type="email" className="input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="partner-email" /></div>
          </div>
          <div className="mt-3 flex gap-2">
            <button type="button" className="btn-primary" onClick={send} disabled={busy || !form.first_name || !form.email} data-testid="partner-invite-send">{busy ? "Sending…" : "Send Invitation"}</button>
            <button type="button" className="btn-quiet" onClick={() => setOpen(false)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};
